'use strict';

var $strSlice = require('call-bind/callBound')('String.prototype.slice');

module.exports = function isPrefixOf(prefix, string) {
	if (prefix === string) {
		return true;
	}
	if (prefix.length > string.length) {
		return false;
	}
	return $strSlice(string, 0, prefix.length) === prefix;
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/helpers/isPrefixOf.js
// module id = 1355
// module chunks = 0